import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { logoutUser } from "../redux/auth/actions";
import Logo from "../assets/images/logonew.webp";
import { Dropdown, Button, Modal } from "react-bootstrap";
import numberWithCommas from "../utils/numbersWithComma";
import Whatsapp from "../assets/images/icons/whatsapp.png";
import DepositIcon from "../assets/images/icons/deposit-icon.webp";
import DollarIcon from "../assets/images/icons/rupee.svg";
import ArrowDown from "../assets/images/icons/arrow-down.webp";
import UserIcon from "../assets/images/icons/user-icon.webp";
import AviatorLogo from "../assets/images/icons/aviator-icon.webp";
import GiftIcon from "../assets/images/icons/gift-icon.webp";
import { AiOutlineClose } from "react-icons/ai";
import Bonuses from "../assets/images/icons/bonuses.webp";
import GamesSearchModal from "../views/components/GamesSearchModal";
import { getNotifications } from "../redux/app/actions";
import { useTranslation } from "react-i18next";
import ThemeSelector from "../views/components/ThemeSelector";

const HeaderAfterLogin = () => {
  const { wallet } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);

  const location = useLocation();
  const [activePage, setActivePage] = useState("");

  const { t } = useTranslation();
  const headerPages = [
    "home",
    "/sportsBook/igPixel",
    "igPixel",
    "sports1",
    "casinogames",
    "livecasino",
    "livegames",
    "casinos",
    "aviator",
    "evolution",
    "ezugi",
    "supernowa",
    "vivo",
    "xpg",
    "worldcasino",
    "qtech",
    "atlas-lobby",
    "/",
    // "spmsports",
  ];
  useEffect(() => {
    const matchedValue = headerPages.find((f) =>
      location?.pathname.includes(f),
    );
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  const [isSticky, setIsSticky] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);
  const [isClassAdded, setIsClassAdded] = useState(false);
  useEffect(() => {
    loadNotifications();
    return () => {};
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      if (currentScrollTop > lastScrollTop && currentScrollTop > 0) {
        // Scrolling down
        setIsSticky(true);
      } else if (currentScrollTop <= 0) {
        // Remove sticky class when scrolled all the way up
        setIsSticky(false);
      }
      setLastScrollTop(currentScrollTop);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollTop]);

  const [isproviderActive, setIsproviderActive] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const inlineStyle = isproviderActive ? { overflowX: "clip" } : {};
  const handleProvidersClick = () => {
    const isMobile = window.innerWidth < 992;

    if (isMobile) {
      setShowModal(true);
      document.body.classList.add("modal-providers-aftrlgn");
      document.documentElement.style.overflow = "hidden";
    } else {
      setIsproviderActive(!isproviderActive);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    document.body.classList.remove("modal-providers");
    document.documentElement.style.overflow = "auto";
  };

  const menuItems = [
    { name: "Home", path: "/", activeKey: "home" },
    {
      name: "Sports",
      path: "/sportsBook/igPixel",
      activeKey: "igPixel",
    },
    {
      name: "Exchange",
      path: "/sports/Cricket",
      activeKey: "sports1",
    },
    { name: "Casinos", path: "/casinos", activeKey: "casinos" },
    { name: "Live-Casino", path: "/livecasino", activeKey: "livecasino" },
    {
      name: "Aviator",
      path: "casino/aggapspribe-aviator",
      activeKey: "aviator",
      isLogo: true,
      logo: AviatorLogo,
    },
    { name: "Slots", path: "/casinogames", activeKey: "casinogames" },
    { name: "Live-games", path: "/livegames", activeKey: "livegames" },
  ];
  const providers = [
    { name: "Evolution", path: "/casino/evolution", activeKey: "evolution" },
    { name: "Ezugi", path: "/casino/aggapezugi-ezugi-lobby", activeKey: "ezugi" },
    { name: "Supernowa", path: "/casino/supernowa", activeKey: "supernowa" },
    { name: "Vivo", path: "/casino/vivo", activeKey: "vivo" },
    // { name: "XPG", path: "/casino/xpg", activeKey: "xpg" },
    // {
    //   name: "Worldcasino",
    //   path: "/casino/worldcasino",
    //   activeKey: "worldcasino",
    // },
    { name: "Qtech", path: "/casino/qtech", activeKey: "qtech" },
    // {
    //   name: "Pragmatic Play",
    //   path: "/pragmaticplay",
    //   activeKey: "pragmaticplay",
    // },
    { name: "Aura", path: "/aura-games", activeKey: "aura" },
    { name: "ALT Gaming", path: "/gap/jiliGaming", activeKey: "gap" },
    { name: "Vimplay", path: "/vimplay", activeKey: "vimplay" },
  ];
  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }} key={idx}>
                {notf?.content}
              </label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}
      <header className="header aftrlgn">
        <div className="top_head d-none d-lg-block">
          <div className="inner-box">
            <div className="left-section">
              {/* <a href="/promotions" className="vip-level">
              <span>Welcome Bonus</span>
              <span className="vip-icon"></span>
              <img src={ArrowRight} alt="right arrow" />
            </a> */}
              <div style={{ backgroundImage: "none" }} className="vip-level">
                <span></span>
              </div>
              <div className="vip-gift">
                <div className="vip-icon">
                  <a
                    className="whatsIcon"
                    href={
                      appDetails?.WHATS_APP_URL != ""
                        ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                        : "#"
                    }
                    target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}>
                    <div className="img-box">
                      <img src={Whatsapp} alt="whatsapp" />
                    </div>
                  </a>
                  <span className="vip-icon1"></span>
                  <span className="vip-icon2"></span>
                  <span className="dot1"></span>
                  <span className="dot2"></span>
                </div>

                {/* <a href="#" className="lucky-draw">
            <div className="text">
              <span>Lucky Drive</span>
              <small>Draw for a brand new Hyundai Creta</small>
            </div>
            <img src={WinningItem} alt="winning item" className="win-itme" />
          </a> */}
              </div>
            </div>

            <div className="right-section">
              <ThemeSelector />
              <div className="vip-gift">
                <a href="/promotions" className="promotion">
                  <div className="img-box">
                    <img src={GiftIcon} alt="promotions" />
                  </div>
                  <span>Promotions and bonuses</span>
                  <img src={Bonuses} alt="bonuses" className="bonus" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className={`bottom_head ${isSticky ? "sticky" : ""}`}>
          <div className="inner-box">
            <div className="logo">
              <a href="/">
                <img src={appDetails?.LOGO_URL} alt="Logo" height={60} />
                {/* <img src={Logo} alt="Logo" /> */}
              </a>
            </div>

            <div className="head-links">
              <ul style={inlineStyle}>
                {menuItems.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.path}
                      className={`
                      ${
                        location.pathname === item.path ||
                        activePage === item.activeKey
                          ? "active"
                          : ""
                      }
                      ${item.name === "Aviator" ? "game-logo" : ""}
                    `}>
                      <span>
                        {item.isLogo ? (
                          <img src={item.logo} alt={item.name} />
                        ) : (
                          item.name
                        )}
                      </span>
                    </a>
                  </li>
                ))}
                <li className="providers">
                  <a href="#" onClick={handleProvidersClick}>
                    <span>Games by provider</span>
                  </a>
                  <ul
                    className={`providers-games d-none d-md-flex ${
                      isproviderActive ? "active" : ""
                    }`}>
                    {providers.map((provider) => (
                      <li key={provider.name}>
                        <a
                          href={provider.path}
                          className={
                            activePage === provider.activeKey ? "active" : ""
                          }>
                          <span>{provider.name}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="d-none d-md-block">
                  <GamesSearchModal />
                </li>
                {/* <li className="providers">
                  <LanguageChange />
                </li> */}
                {/* <li className="providers">
                <a
                  href="/atlas-lobby"
                  className={activePage === "atlas-lobby" ? "active" : ""}
                >
                  <span>Sportsbook 2</span>
                </a>
              </li> */}
              </ul>

              <div className="d-lg-none">
                <GamesSearchModal />
              </div>
            </div>

            <div className="rightSec ms-lg-auto">
              <div className="bal-dpst">
                <div className="balance">
                  <span>
                    <span className="notranslate">&nbsp;</span>
                    <Dropdown align="center" className="balanceDropdown">
                      <Dropdown.Toggle variant="success" id="dropdown-balance">
                        <img src={ArrowDown} alt="balance" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <div className="bal real">
                          <p>Main Wallet</p>
                          <div className="box">
                            {/* <div className="img-box">
                              <img src={DollarIcon} alt="rupee" />
                            </div> */}
                            <div className="amnt">
                              {numberWithCommas(wallet?.balance)}
                            </div>
                            <div className="dpst">
                              <a href="/gatewaylist">
                                <img src={DepositIcon} alt="deposit" />
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="bal cash">
                          <p>Cash</p>
                          <div className="box">
                            {/* <div className="img-box">
                              <img src={DollarIcon} alt="rupee" />
                            </div> */}
                            <div className="amnt">
                              {numberWithCommas(wallet?.cash)}
                            </div>
                          </div>
                        </div>
                        <div className="bal bonus">
                          <p>Bonus</p>
                          <div className="box">
                            {/* <div className="img-box">
                              <img src={DollarIcon} alt="rupee" />
                            </div> */}
                            <div className="amnt">
                              {numberWithCommas(wallet?.coins)}
                            </div>
                          </div>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </span>
                  <strong>{wallet?.balance}</strong>
                </div>
                {/* <DepositModal /> */}
                <div className="dpst-btn">
                  <a href="/gatewaylist" className="btn">
                    Deposit
                  </a>
                </div>
              </div>

              <Dropdown align="end" className="userDropdown">
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <img src={UserIcon} alt="user" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item href="/profile">Profile</Dropdown.Item>

                  <Dropdown.Item href="/withdraw">Withdrawal</Dropdown.Item>
                  <Dropdown.Item href="/mybets">Bets History</Dropdown.Item>
                  <Dropdown.Item href="/referral">Referral</Dropdown.Item>
                  <Dropdown.Item href="/bonus">Bonus</Dropdown.Item>
                  <Dropdown.Item href="/cashier">Statement</Dropdown.Item>
                  <Dropdown.Item href="/deposit/list">
                    Deposit History
                  </Dropdown.Item>
                  <Dropdown.Item href="/withdrawList">
                    Withdraw History
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#"
                    onClick={() => dispatch(logoutUser())}>
                    Log Out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>

        <Modal
          className="providers-list"
          show={showModal}
          onHide={handleModalClose}
          size="sm"
          aria-labelledby="contained-modal-title-vcenter">
          <Modal.Body>
            <div className="providers-link">
              <ul>
                {providers.map((provider) => (
                  <li key={provider.name}>
                    <a
                      href={provider.path}
                      className={
                        activePage === provider.activeKey ? "active" : ""
                      }>
                      <span>{provider.name}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </Modal.Body>
        </Modal>
      </header>
    </>
  );
};

export default HeaderAfterLogin;
